// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"535":"login","942":"not-found"}[chunkId] + "." + {"535":"7024268b","942":"7d45149c"}[chunkId] + ".js";
};